module.exports = {
  "id": "1e798ecc-343c-4d6b-9d70-4e368fa88a25",
  "gtmIds": [
    "GTM-NP7PCZV6",
    "GTM-T2TNT6",
    "GTM-KKS578WK"
  ],
  "startTracking": "after_accepting_cookies",
  "hasInAppVersion": false,
  "group": "moreys",
  "language": "en-US",
  "defaultDateFormat": "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL",
  "defaultNumberFormat": null,
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "en-US"
  ],
  "website": "https://www.panamericanhotel.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}